<script lang="ts">
    import JobOneRow from './JobOneRow.svelte';

    export let componentProps: any;
</script>

<JobOneRow {...componentProps} />